import { useCallback, useContext, useMemo } from "react";

import SessionContext from "app/contexts/SessionContext";
import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const PAGE_CODE = "AC_PLANNER_VIEW";

export const useLeadProducerEmp = () => {
    const { getDataAsync } = useApi();
    const session = useContext(SessionContext);

    const pageIdVal = session.permissions.find(f => f.pageRoute === globalThis.config.routes.projectsDashboardLanding)?.pageId;

    const getLeadProducerEmpIdsApiCall = useCallback(async () => {
        if (pageIdVal >= 0) {
            const response = await getDataAsync("getLeadProducerEmpIds", {
                urlParams: [
                    { name: "$pageId", value: pageIdVal },
                    { name: "$code", value: PAGE_CODE }
                ],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        } else {
            return null;
        }
    }, [getDataAsync, pageIdVal]);

    const leadProducerEmpIds = useQuery(
        "leadProducerEmpIdData",
        getLeadProducerEmpIdsApiCall
    );

    return useMemo(() => {
        return {
            leadProducerEmpIds,
        };
    }, [leadProducerEmpIds]);
};
